import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedPhone = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="phone" size="100%" color={stroke ?? color} />
);

export { LineRoundedPhone };
